import React, { useState, useEffect } from "react";
import { getAllBlogPosts } from "../../../../../ApiLayer/admin";
import { getBlogPost } from "../../../../../ApiLayer/admin";
import styles from './SelectABlogPost.module.scss';
import { useEditor, EditorContent } from "@tiptap/react";
import { extensions } from "../../../../../util/tiptapExtensions";

const SelectABlogPost = ({ onPostSelect }) => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedPostTitle, setSelectedPostTitle] = useState("");
  const [selectedPost, setSelectedPost] = useState(null);

  const editor = useEditor({
    extensions,
    content: selectedPost?.content || "",
    editable: false,
});

  const fetchAllPosts = async () => {
    setLoading(true);
    try {
      const response = await getAllBlogPosts();

      if (!response.success) {
        // console.log("Error fetching all blog posts.");
        setMessage("Error fetching all blog posts.");
        return;
      }

      setBlogPosts(response.posts || []);
    } catch (err) {
      // console.log("Error fetching all blog posts:", err);
      setMessage("Error fetching all blog posts.");
    } finally {
      setLoading(false);
    }
  };

  const fetchSelectedPost = async (title) => {
    if (!title) return;

    setLoading(true);
    try {
      const response = await getBlogPost({ title });

      if (!response.success) {
        // console.log("Error fetching blog post.");
        setMessage("Error fetching blog post.");
        return;
      }

      setSelectedPost(response.post);
      if (editor) {
        editor.commands.setContent(response.post.content);
      }
    } catch (err) {
      // console.log("Error fetching blog post:", err);
      setMessage("Error fetching blog post.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllPosts();
  }, []);

  useEffect(() => {
    if (selectedPostTitle) {
      fetchSelectedPost(selectedPostTitle);
    }
  }, [selectedPostTitle]);

  const handlePostSelect = (e) => {
    const title = e?.target?.value;
    if (!title) return;

    setSelectedPostTitle(title);
    const selectedPost = blogPosts.find(post => post.title === title);
    if (selectedPost && onPostSelect) {
      onPostSelect(selectedPost);
    }
  };

  return (
    <div className={styles.blogPostSelector}>
      {message && <div className={styles.message}>{message}</div>}
      
      <select
        value={selectedPostTitle}
        onChange={handlePostSelect}
        className={styles.postSelect}
        disabled={loading || blogPosts.length === 0}
      >
        <option value="">Select a blog post</option>
        {blogPosts.map((post) => (
          <option key={post._id} value={post.title}>
            {post.title}
          </option>
        ))}
      </select>
      
      {loading && <div className={styles.loading}>Loading...</div>}
    </div>
  );
};

export default SelectABlogPost;
